module.exports = __webpack_public_path__ + "img/161.8be47433.jpg";